export class CustomerSpecificDesignation {
    constructor() {
        this.specificDesignation = false;
        this.inventoryNumber = null;
        this.equipmentDescription = null;
        this.posLocation = null;
        this.constructionNumber = null;
    }
}
